(function () {
    'use strict';
    var auth = {};
     const keycloakObj = {
        "realm": "quantix",
       "url": "/auth",
        "auth-server-url": "/auth",
        "ssl-required": "all",
        "clientId": "quantix",
        "public-client": true,
        "verify-token-audience": true,
        "use-resource-role-mappings": true,
        "confidential-port": 0
     };

    // const keycloakObj = {
    //     "realm": "jhipster",
    //     "url": "/auth",
    //     "auth-server-url": "/auth",
    //     "ssl-required": "all",
    //     "clientId": "CLIENT-ID-NAME",
    //     "public-client": true,
    //     "verify-token-audience": true,
    //     "use-resource-role-mappings": true,
    //     "confidential-port": 0
    // };

    angular.element(document).ready(function ($http) {
        var keycloakAuth = new Keycloak(keycloakObj);
        auth.loggedIn = false;

        keycloakAuth.init({ onLoad: 'login-required' }).success(function () {
            auth.loggedIn = true;
            auth.authz = keycloakAuth;
            const port = location.port.length == 0 ? "" : ":".concat(location.port);
            auth.logoutUrl = location.protocol.concat('//', location.hostname, port, location.pathname);
            angular.module('quantixApp').factory('AuthKeycloak', function () {
                return auth;
            });
            angular.bootstrap(document, ['quantixApp']);
        }).error(function () {
            window.location.reload();
        });

    });
})();